import styled, { css } from 'styled-components'
import { color, fontSize, transition } from 'utils/styledHelper'

const DarkTabMenuItem = styled.div<{ selected: boolean }>`
  padding: 0.5rem 1.5rem;
  margin: 2px;
  color: ${color('whiteAlpha50')};
  border-radius: 0.4rem;
  transition: background ${transition('fast')};
  flex: 1 1 auto;
  font-size: ${fontSize('xs')};
  font-weight: 600;
  line-height: 1.25rem;
  text-align: center;

  :hover {
    background: ${color('dark800')};
    cursor: pointer;
  }

  :active {
    background: ${color('dark900')};
    color: ${color('blue400')};
  }

  :focus {
    outline: none;
    background: ${color('dark900')};
    color: ${color('blue400')};
  }

  ${(props) =>
    props.selected &&
    css`
      background: ${color('dark900')};
      color: ${color('blue400')};
    `}
`

export default DarkTabMenuItem
